module.exports = __webpack_public_path__ + "img/multicare.76b951c0.png";